/**
 * Recurso de tradução para elementos comuns
 */

import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { commonTranslationRef } from './common';

export const commonTranslations = createTranslationResource({
  ref: commonTranslationRef,
  translations: {
    'pt-BR': () => import('./common-pt-BR'),
  },
});
